<h2 mat-dialog-title> {{ title }} </h2>
<div mat-dialog-content>
 	<div fxLayout="row">
        <div fxFlex = "100" [innerHTML]="custom_message">
		</div>
	</div>
</div>
